import SectionShell from "@/pages/home/components/SectionShell";
import { highlights, siteName } from "@/mocks/home";

export default function HighlightsSection() {
  return (
    <SectionShell
      id="highlights"
      num="03"
      eyebrow="KEY MOMENTS"
      title="看点卡片：四个值得停留的段落"
      desc="按顺序把画面、配乐、对照与结局拆成四张大图卡片，先感受，再决定要不要收藏全片。"
    >
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8">
        {highlights.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
          >
            <div className="relative aspect-[8/5] w-full overflow-hidden">
              <img
                src={item.image}
                alt={`${siteName} ${item.title} 高清剧照`}
                title={`${siteName} ${item.title}`}
                className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium tracking-wide text-accent-700 backdrop-blur">
                {item.kicker}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{item.desc}</p>
              <div className="mt-5 flex items-center gap-2 text-sm font-medium text-accent-600">
                <span className="h-px w-6 bg-accent-400" />
                完整版中可见
              </div>
            </div>
          </article>
        ))}
      </div>
    </SectionShell>
  );
}